'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    // init gallery
    (0, _jquery2.default)('.gallery', this).each(function () {
        // the containers for all your galleries
        (0, _jquery2.default)(this).magnificPopup({
            delegate: 'a', // the selector for gallery item
            type: 'image',
            gallery: {
                enabled: true
            }
        });
    });

    // open image in
    (0, _jquery2.default)('.show-in-lightbox', this).magnificPopup({
        type: 'image',
        removalDelay: 500,
        closeOnContentClick: true,
        midClick: true // allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source.
    });
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/gallery.js
// module id = 931
// module chunks = 0